<template>
  <select-dictionary
    :title="$tr('vacancy.settings.talentq.project-assessments')"
    :value="value"
    :loaded="loaded"
    :error="error"
    :list="list"
    @input="$emit('input', $event)"
  />
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import SelectDictionary from '../../components/project/select-dictionary';
  import { TALENTQ_STORE_NAMES } from '@/stores_new/vacancy_talentq/constants';

  export default {
    name: 'AssessmentCode',

    components: {
      SelectDictionary
    },

    props: {
      value: {
        type: Number,
        default: null
      }
    },

    computed: {
      ...mapGetters('vacancy_talentq/' + TALENTQ_STORE_NAMES.DICTIONARY_ASSESSMENT, [
        'loaded',
        'error',
        'list'
      ])
    },

    created() {
      this.load();
    },

    methods: {
      ...mapActions('vacancy_talentq/' + TALENTQ_STORE_NAMES.DICTIONARY_ASSESSMENT, ['load'])
    }
  };
</script>
